import "./ModalDelete.scss";
import React from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import close from "../../assets/Icons/close-24px.svg";

const apiURL = `https://instock-api-rbht.onrender.com`;

const ModalDelete = ({ handleClose, show, target, name, id }) => {
  // change class to show/hide based on show state passed with props
  const showHideClassName = show
    ? "modal-wrapper display-flex"
    : "modal-wrapper display-none";

  let changeDescription = "";
  let changeTitle = "";
  if (target === "warehouse") {
    changeDescription = "from the list of warehouses";
    changeTitle = "warehouse";
  } else {
    changeDescription = `from the Inventory list`;
    changeTitle = "inventory item";
  }

  // Axios call to delete item or warehouse depending on the props passed down
  function handleDelete() {
    let apiTarget = "";
    if (target === "inventory") {
      apiTarget = "inventories";
    } else {
      apiTarget = "warehouses";
    }
    console.log(id);
    axios
      .delete(`${apiURL}/api/v1/${apiTarget}/${id}`)
      .then((res, req) => {
        if (res.status === 200) {
          console.log("deleted");
          console.log(res);
          handleClose();
        }
      })
      .catch((err) => {
        //catch in case of error console log it
        console.log(err);
      });
  }

  return (
    <div role="button" className={showHideClassName}>
      <div className="modal-item">
        <button className="modal-item__close" onClick={handleClose}>
          <img className="modal-item__close-img" src={close} alt="close X" />
        </button>
        <div className="modal-item-text">
          <h1 className="modal-item-text__title">
            {`Delete ${name} ${changeTitle}?`}
          </h1>
          <p className="modal-item-text__description">
            {`Please confirm that you’d like to delete ${name} 
            ${changeDescription}. You won’t be able to undo this action.`}
          </p>
        </div>
        <div className="modal-item-buttons">
          <button className="modal-item-buttons__cancel" onClick={handleClose}>
            Cancel
          </button>
          <button className="modal-item-buttons__delete" onClick={handleDelete}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default withRouter(ModalDelete);
